module.exports = __webpack_public_path__ + "static/media/FolderListBookmark.2404aa7c.png";